// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__TzX+a","checkbox__box":"Checkbox_checkbox__box__VTkRd","error":"Checkbox_error__uRg9q"};